<template>
  <div class="container">
    <div class="header">
      <div class="hea-top">
        <van-cell is-link @click="showPopup" :class="upDown">{{ selectName }}</van-cell>
        <van-popup
          v-model="show"
          position="bottom"
          @close="closeDU"
          round
          :style="{ height: '30%' }"
        >
          <van-picker :columns="columns" :defaultIndex="curWeek" @change="onChange" />
        </van-popup>
      </div>
    </div>
    <div class="footer" v-if="!isData">
      <div class="self-sweiper">
        <div class="content-swiper">
          <ul
            :style="
              !addTodaySt ? (slideRow.length > 16 ? 'min-width: 1500px;' : 'min-width: 800px;') : ''
            "
          >
            <li
              :class="item.selected ? 'selected' : ''"
              v-for="(item, index) in slideRow"
              :key="index"
              @click="handleTime(index, item)"
            >
              <p>{{ item.name }}</p>
              <p v-if="item.day">{{ item.day }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="class-tbl">
        <div v-if="!tableDt && liScheduleData && liScheduleData.length > 0" class="tab-line">
          <table>
            <tbody>
            <tr v-for="(item, index) in liScheduleData" :key="index">
              <td>
                <div
                  class="border-line"
                  :style="{
                      top: index * 1 === 0 ? '50%' : '0',
                      height:
                        index * 1 === liScheduleData.length - 1 ||
                        index === liScheduleData.length - 1
                          ? '50%'
                          : ''
                    }"
                ></div>
              </td>
              <td>
                <img
                  :src="require('@/assets/csmsTimeTable/need-class.png')"
                  v-if="item.subject"
                />
                <img :src="require('@/assets/csmsTimeTable/no-class.png')" v-else />
              </td>
              <td>
                <p>{{ item.Times.AMorPMOrderName }}</p>
                <p v-if="item.Times.date">{{ item.Times.date }}</p>
              </td>
              <td>
                <div
                  v-if="item.subject"
                  :style="{ backgroundColor: item.subject.bg, color: item.subject.color }"
                  :class="addTodaySt ? '' : 'sub-name'"
                >
                  <p>
                    {{ item.subject.SubjectName ? item.subject.SubjectName + "" : "" }}
                    {{
                    role === 3
                    ? item.subject.TeacherInfos
                    ? "&nbsp;|&nbsp;" + item.subject.TeacherInfos
                    : ""
                    : item.subject.CoursePlanTableFullName
                    ? "&nbsp;|&nbsp;" + item.subject.CoursePlanTableFullName
                    : ""
                    }}
                    {{
                    item.subject.BuildingName
                    ? "&nbsp;|&nbsp;" + item.subject.BuildingName + "/"
                    : ""
                    }}{{ item.subject.HouseName ? item.subject.HouseName : "" }}
                  </p>
                  <p v-if="addTodaySt">
                    {{ item.subject.StartTime ? item.subject.StartTime : "" }}-{{
                    item.subject.EndTime ? item.subject.EndTime : ""
                    }}
                  </p>
                  <p>
                    <van-button type="primary" @click="openUrl(item.subject.ZBUrl, item)" :disabled="!item.subject.ZBUrl" size="small">直播</van-button>
                    <van-button style="margin-left: 15px;" type="primary" @click="openUrl(item.subject.DBUrl, item)" :disabled="!item.subject.DBUrl" size="small">点播</van-button>
                  </p>
                </div>
                <div class="no-dt" v-if="!item.subject">
                  <p>暂无数据</p>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <no-data v-show="tableDt" class="class-tbl" :needBg="true"></no-data>
      </div>
    </div>
    <no-data v-show="isData" :needBg="true" class="footer"></no-data>
  </div>
</template>
<script>
  import noData from "@/components/noData/Index";
  export default {
    name: "mySchedule",
    components: {
      noData
    },
    data() {
      return {
        role: localStorage.getItem("role") * 1,
        columns: [],
        show: false,
        addTodaySt: true, // 周或者今
        upDown: "", // select下拉动画
        slideRow: [], // 滑动行
        resDataListWeek: "", // 获取周次信息
        curWeek: 0, //第几周
        selectName: "第1周",
        liScheduleData: [], //当天课表课程
        studentsData: [],
        sectionList: [
          "1节",
          "2节",
          "3节",
          "4节",
          "5节",
          "6节",
          "7节",
          "8节",
          "9节",
          "10节",
          "11节",
          "12节"
        ],
        zaoData: ["早1", "早2"],
        wanData: ["晚1", "晚2", "晚3", "晚4"],
        //学年学期
        yearID: 0,
        yearData: [],
        sessionID: 0,
        sessionData: [],
        aMorPM: "", // 周时选中第几节
        aMorPMOrder: 0,
        TimeTables: [],
        isData: false,
        tableDt: true,
        curDay: 0,
        currentWeek: 0 // 用于标记本周在数组中的位置，点击切换时去改变下拉列表的值和显示
      };
    },
    created() {
      this.getYear();
    },
    mounted() {},
    methods: {
      openUrl: function (url, data) {
        let paramsUrl = url +`&ticket=${this.xy.getCookie('.XYTOKEN')}&origin_flag=1&ClassTableGenerateBaseID=${data.subject.ClassTableGenerateBaseID}&accountNumber=${this.BROADCAST_accountNumber}`
        window.open(paramsUrl)
      },
      // 点击切换表格
      handleTime(index, val) {
        // this.tableDt = true
        this.slideRow.map(val => {
          return (val.selected = false);
        });
        this.slideRow[index].selected = true;
        if (this.addTodaySt) {
          this.curDay = index;
          this.getWeekTimeTable(this.slideRow[index].comDay);
        } else {
          this.aMorPM = val.AMorPM;
          this.aMorPMOrder = val.AMorPMOrder;
          this.GetTab();
        }
      },
      showPopup() {
        this.show = true;
        this.upDown = "up";
      },
      onChange(picker, value, index) {
        // Toast(`当前值：${value}, 当前索引：${index}`);
        if (value.length === 2 ? value : value.substr(0, value.length - 21) !== this.selectName) {
          this.curWeek = index;
          this.selectName = value.length === 2 ? value : value.substr(0, value.length - 21);
          this.slideRow = [];
          if (!this.addTodaySt) {
            this.getWeekTimeTable();
          } else {
            this.changeTime();
          }
        }
      },
      // 切换今天或者周
      stayToday(val) {
        if (val === this.addTodaySt) return;
        this.curWeek = this.currentWeek;
        this.selectName = "本周";
        this.slideRow = [];
        this.addTodaySt = !this.addTodaySt;
        if (this.addTodaySt) {
          this.changeTime();
        } else {
          this.getWeekTimeTable();
        }
      },
      closeDU() {
        this.upDown = "down";
      },
      // 改变周时间
      changeTime() {
        for (let i = 0; i < 7; i++) {
          this.slideRow.push({
            id: 1000011 + i,
            name: this.xy.getChinesesWeekForNumSmall(i),
            selected:
              new Date(
                new Date(this.resDataListWeek[this.curWeek].Date).getTime() + i * 24 * 3600 * 1000
              ).pattern("yyyy-MM-dd") === new Date(new Date()).pattern("yyyy-MM-dd")
                ? true
                : false,
            day:
              new Date(
                new Date(this.resDataListWeek[this.curWeek].Date).getTime() + i * 24 * 3600 * 1000
              ).getMonth() +
              1 +
              "/" +
              new Date(
                new Date(this.resDataListWeek[this.curWeek].Date).getTime() + i * 24 * 3600 * 1000
              ).getDate(),
            comDay: new Date(
              new Date(this.resDataListWeek[this.curWeek].Date).getTime() + i * 24 * 3600 * 1000
            ).pattern("yyyy-MM-dd")
          });
          if (
            new Date(
              new Date(this.resDataListWeek[this.curWeek].Date).getTime() + i * 24 * 3600 * 1000
            ).getDate() === new Date().getDate() &&
            this.selectName === "本周"
          ) {
            // 为本周时调用
            this.curDay = i;
            this.getWeekTimeTable(
              new Date(
                new Date(this.resDataListWeek[this.curWeek].Date).getTime() + i * 24 * 3600 * 1000
              ).pattern("yyyy-MM-dd")
            );
          }
        }
        // 不为本周时调用
        if (this.selectName !== "本周") {
          this.slideRow[this.curDay].selected = true;
          this.getWeekTimeTable(this.slideRow[this.curDay].comDay);
        }
        // }
      },
      //获取周课表
      async getWeekTimeTable(date) {
        this.xy.loading();
        this.liScheduleData = [];
        /***
         * startDate
         * endDate
         * true 传的为今，false为周
         */
        let res = await this.xyapi.get(
          this.$store.state.apiPath + "/api/OnLineTeaching/GetWeekTimeTable",
          {
            startDate: !this.addTodaySt
              ? new Date(this.resDataListWeek[this.curWeek].Date).pattern("yyyy-MM-dd")
              : date,
            endDate: !this.addTodaySt
              ? new Date(
                new Date(this.resDataListWeek[this.curWeek].Date).getTime() + 6 * 24 * 3600 * 1000
              ).pattern("yyyy-MM-dd")
              : date
            // startDate: '2019-10-28',
            // endDate: '2019-10-28'
          }
        );
        this.xy.unloading();
        if (res.success) {
          if (res.data.Times.length > 0) {
            this.isData = false;
            if (this.addTodaySt) {
              // 今
              for (let item in res.data.Times) {
                res.data.Times[item].id = 10000 + item;
                this.liScheduleData.push({
                  Times: res.data.Times[item]
                });
                for (let clas of res.data.TimeTables) {
                  if (
                    this.curDay === clas.Day &&
                    res.data.Times[item].AMorPM === clas.AMorPM &&
                    res.data.Times[item].AMorPMOrder === clas.AMorPMOrder
                  ) {
                    this.$set(this.liScheduleData[item], "subject", clas);
                  }
                }
              }
            } else {
              // 周
              this.aMorPM = res.data.Times[0].AMorPM;
              this.aMorPMOrder = res.data.Times[0].AMorPMOrder;
              this.slideRow = res.data.Times.map((item, index) => {
                if (item.AMorPM === "MS") {
                  item.name = this.zaoData[item.Order];
                } else if (item.AMorPM === "NS") {
                  item.name = "午休";
                } else if (item.AMorPM === "ES") {
                  item.name = this.wanData[item.Order];
                } else if (item.AMorPM === "AM" || item.AMorPM === "PM") {
                  item.name = this.sectionList[item.Order];
                }
                item.id = 10000 + index;
                item.selected = index === 0 ? true : false;
                item.aMorPMOrder = item.AMorPM;
                item.aMorPM = item.AMorPMOrder;
                return item;
              });
            }
          }

          if (res.data.TimeTables.length > 0) {
            this.tableDt = false;
            this.TimeTables = res.data.TimeTables;
            if (!this.addTodaySt) {
              this.GetTab();
            }
            let array = [];
            for (let i = 0; i < res.data.TimeTables.length; i++) {
              let index = array.indexOf(res.data.TimeTables[i].SubjectName);
              if (index > -1) {
                res.data.TimeTables[i].color = this.xy.colors(index).color;
                res.data.TimeTables[i].bg = this.xy.colors(index).bg;
              } else {
                res.data.TimeTables[i].color = this.xy.colors(array.length).color;
                res.data.TimeTables[i].bg = this.xy.colors(array.length).bg;
                array.push(res.data.TimeTables[i].SubjectName);
              }
              if (res.data.TimeTables[i].StartTime) {
                res.data.TimeTables[i].StartTime = res.data.TimeTables[i].StartTime.substr(
                  0,
                  res.data.TimeTables[i].StartTime.length - 3
                );
              }
              if (res.data.TimeTables[i].EndTime) {
                res.data.TimeTables[i].EndTime = res.data.TimeTables[i].StartTime.substr(
                  0,
                  res.data.TimeTables[i].EndTime.length - 3
                );
              }
            }
          } else {
            this.tableDt = true;
          }
        }
      },
      // 当前为周时
      GetTab() {
        this.liScheduleData = [];
        let i = 0;
        while (i < 7) {
          this.liScheduleData.push({
            Times: {
              AMorPMOrderName: this.xy.getChinesesWeekForNumSmall(i),
              date:
                new Date(
                  new Date(this.resDataListWeek[this.curWeek].Date).getTime() + i * 24 * 3600 * 1000
                ).getMonth() +
                1 +
                "/" +
                new Date(
                  new Date(this.resDataListWeek[this.curWeek].Date).getTime() + i * 24 * 3600 * 1000
                ).getDate()
            }
          });
          for (let item of this.TimeTables) {
            if (
              i === item.Day &&
              this.aMorPM === item.AMorPM &&
              this.aMorPMOrder === item.AMorPMOrder
            ) {
              this.$set(this.liScheduleData[i], "subject", item);
            }
          }
          i++;
        }
      },
      //获取周次信息
      async getWeek(id) {
        this.xy.loading();
        let res = await this.xyapi.get(this.$store.state.apiPath + "/api/MyTimeTable/GetWeek", {
          academicSessionID: id
        });
        this.xy.unloading();
        if (res.success) {
          if (!res.data.ListWeek && res.data.ListWeek.length <= 0) {
            this.isData = true;
            this.liScheduleData = [];
            return;
          }
          this.isData = false;
          this.resDataListWeek = res.data.ListWeek;
          this.columns = res.data.ListWeek.map((val, index) => {
            if (val.Week !== "本周") {
              return `第${val.Week}周${new Date(val.Date).pattern("yyyy/MM/dd")}-${new Date(
                new Date(val.Date).getTime() + 6 * 24 * 3600 * 1000
              ).pattern("yyyy/MM/dd")}`;
            } else {
              this.curWeek = index;
              this.selectName = "本周";
              this.currentWeek = index;
              return val.Week;
            }
          });
          this.changeTime();
        } else {
          this.$toast.fail(res.msg);
        }
      },
      //获取学年
      async getYear() {
        this.xy.loading();
        let res = await this.xyapi.get(this.$store.state.apiPath + "/xy/comm/YearList");
        this.xy.unloading();
        if (res.success) {
          this.yearData = res.data;
          if (res.data.length > 0) {
            var arr = res.data.filter(function(item) {
              return item.IsCurrent === true;
            });
            if (arr.length > 0) {
              this.yearID = arr[arr.length - 1].ID;
              // this.yearID = res.data[1].ID
            } else {
              this.yearID = res.data[res.data.length - 1].ID;
            }
          }
          this.getSession(this.yearID);
        } else {
          this.$toast.fail(res.data);
        }
      },
      //获取学期
      async getSession(id) {
        this.xy.loading();
        let res = await this.xyapi.get(this.$store.state.apiPath + "/xy/comm/SessionList", {
          yearID: id
        });
        this.xy.unloading();
        if (res.success) {
          this.sessionData = [];
          this.sessionID = 0;
          if (res.data.length > 0) {
            this.sessionData = res.data;
            var arr = res.data.filter(function(item) {
              return item.IsCurrent === true;
            });
            if (arr.length > 0) {
              this.sessionID = arr[arr.length - 1].AcademicSessionID;
            } else {
              this.sessionID = res.data[res.data.length - 1].AcademicSessionID;
            }
          }
          this.getWeek(this.sessionID);
        } else {
          this.$toast.fail(res.data);
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .container {
    position: relative;
    .footer {
      position: relative;
      top: -265px;
      .class-tbl {
        margin-top: 25px;
        padding: 30px 50px 55px 33px;
        background-color: #f9f9f9;
        border-radius: 66px 66px 0px 0px;
        position: relative;
        min-height: 300px;
        .tab-line {
          position: relative;
        }
        .border-line {
          position: absolute;
          height: 100%;
          border-left: 1px dashed rgba(182, 186, 202, 0.5);
          width: 1px;
          left: 18px;
        }
        table {
          width: 100%;
          tbody {
            tr {
              text-align: center;
              td:nth-of-type(1) {
                position: relative;
              }
              td:nth-of-type(2) {
                width: 40px;
                height: 40px;
                img {
                  width: 40px;
                  height: 40px;
                  position: relative;
                  // z-index: 1000;
                }
              }
              td:nth-of-type(3) {
                color: #333333;
                font-size: 24px;
                min-width: 70px;
                p:nth-of-type(1) {
                  padding: 13px 0;
                }
              }
              td:nth-of-type(4) {
                flex: 1 0 auto;
                text-align: left;
                color: #2664d1;
                min-height: 150px;
                min-width: 350px;
                div {
                  font-size: 28px;
                  min-height: 100px;
                  background-color: rgba(52, 121, 205, 0.2);
                  border-radius: 14px;
                  margin: 14px 0;
                  padding: 20px;
                  // padding-left: 20px;
                  line-height: 1.5;
                }
                .no-dt {
                  display: flex;
                  justify-content: center;
                  p {
                    align-self: center;
                  }
                }
                .sub-name {
                  display: flex;
                  align-content: center;
                  p {
                    align-self: center;
                  }
                }
              }
            }
            tr:nth-of-type(2 + n) {
              margin-top: 48px;
            }
          }
        }
      }
      .self-sweiper {
        height: 100px;
        overflow: hidden;
        .content-swiper {
          height: 120px;
          overflow-y: hidden;
          overflow-x: scroll;
          ul {
            display: flex;
            // width: 926px;
            width: 1000px;
            justify-content: space-between;
            padding: 0 40px;
            li {
              box-sizing: border-box;
              width: 110px;
              height: 100px;
              border-radius: 24px;
              color: #f9f9f9;
              text-align: center;
              background: rgba(249, 249, 249, 0.2);
              line-height: 1.5;
              p:nth-of-type(1) {
                font-weight: bold;
              }
              display: flex;
              flex-flow: column nowrap;
              justify-content: center;
              align-items: center;
            }
            .selected {
              background-color: rgba(249, 249, 249, 1);
              p:nth-of-type(1) {
                color: #070061;
                font-size: 28px;
              }
              p:nth-of-type(2) {
                color: #9d97bd;
                font-size: 24px;
              }
            }
          }
        }
      }
    }
    .txt-ct {
      text-align: center;
    }
    .header {
      height: 523.5px;
      background-image: url("../../../../assets/csmsTimeTable/my-schedule-bg.png");
      background-size: 100%;
      font-size: 28px;
      color: #f9f9f9;
      .hea-top {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 66px;
        .span-day {
          border: 1px solid rgba(255, 255, 255, 1);
          border-radius: 50%;
          display: inline-block;
          padding: 50px;
        }
        .span-day-selected {
          background-color: rgb(255, 255, 255, 0.9);
          color: #1158ea;
        }
        .span-week {
          border: 1px solid rgba(255, 255, 255, 1);
          border-radius: 50%;
          display: inline-block;
          padding: 50px;
        }
        .van-cell {
          background-color: rgba(0, 0, 0, 0.15);
          border-radius: 20px;
          width: 240px;
          height: 84px;
          margin: 0 5%;
        }
        .van-cell:not(:last-child):after {
          border-bottom: 0px;
        }
        .van-cell__right-icon {
          color: #fff;
        }
        .van-icon-arrow:before {
          content: "\F007";
        }
        .van-cell__value--alone {
          text-align: center;
        }
        .down {
          .van-icon-arrow {
            animation: fadings 0.2s ease-in-out 0s 1;
            animation-fill-mode: forwards;
          }
          @keyframes fadings {
            0% {
              transform: rotate(-180deg);
            }
            50% {
              transform: rotate(-90deg);
            }
            100% {
              transform: rotate(0deg);
            }
          }
        }
        .up {
          .van-icon-arrow {
            animation: fading 0.2s ease-in-out 0s 1;
            animation-fill-mode: forwards;
          }
          @keyframes fading {
            0% {
              transform: rotate(0deg);
            }
            50% {
              transform: rotate(-90deg);
            }
            100% {
              transform: rotate(-180deg);
            }
          }
        }
        .van-cell__value--alone {
          color: #fff;
        }
      }
    }
  }
</style>
